import { render, staticRenderFns } from "./ArticlesItem.vue?vue&type=template&id=0587705a&"
import script from "./ArticlesItem.vue?vue&type=script&lang=js&"
export * from "./ArticlesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports